import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter } from 'react-router-dom';
import IntercomBoot from './components/IntercomBoot';
import TokenProbe from "./components/TokenProbe";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
    authorizationParams={{ redirect_uri: window.location.origin }}
    useRefreshTokens
    useRefreshTokensFallback={false} 
    cacheLocation="localstorage"
  >
    <React.StrictMode>
      <BrowserRouter>
        <TokenProbe />
        <App />
      </BrowserRouter>
    </React.StrictMode>
    <IntercomBoot />
  </Auth0Provider>
);

reportWebVitals();
